import PropTypes from 'prop-types';

import Button from '@zenbusiness/zui/Button';
import CardHeader from '@zenbusiness/zui/CardHeader';
import ZuiLink from '@zenbusiness/zui/Link';
import Text from '@zenbusiness/zui/Text';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

import * as Styled from './WebinarCard.styles';

function WebinarCard({
  actionLabel,
  description,
  imagePath,
  internalUrl,
  mobileImagePath = null,
  title
}) {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const imageUrl = (isMobile && mobileImagePath) ? mobileImagePath : (imagePath || mobileImagePath);

  return (
    <Styled.CardWrapper>
      <Styled.Image src={imageUrl} alt={title} />
      <Styled.ContentWrapper>
        <CardHeader
          subtitle={description}
          title={<Text size="md">{title}</Text>}
        />
        <Button
          clickstreamProps={{
            elementName: 'opening_webinar',
            elementValue: title
          }}
          color="primary"
          component={ZuiLink}
          variant="outlined"
          size="sm"
          to={internalUrl}
          sx={{
            gap: 0.5,
            width: 'auto'
          }}
        >
          {actionLabel}
        </Button>
      </Styled.ContentWrapper>
    </Styled.CardWrapper>
  );
}

WebinarCard.propTypes = {
  actionLabel: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imagePath: PropTypes.string.isRequired,
  internalUrl: PropTypes.string.isRequired,
  mobileImagePath: PropTypes.string,
  title: PropTypes.string.isRequired
};

export default WebinarCard;
